module.exports = __webpack_public_path__ + "img/20.dface501.jpeg";